import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { Container } from '../../design';
import { CtaBand } from './CtaBand';
import { ShopFront, Spot } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { NextLink, ProductFaq, ProductHero, ProductSection, ProductStep, ProductSteps } from './ProductParts';
import './product-hunts.css';
const MATCHES = [
    {
        car: '1995 Land Cruiser VX · 4 · 142k km',
        price: '¥2.10–2.35M'
    },
    {
        car: '1996 Land Cruiser VX-LTD · 4 · 168k km',
        price: '¥2.30–2.60M'
    }
];
const DETAILS = [
    {
        title: 'Your words, your mailbox',
        text: 'Signed by you and sent from your own mailbox once you approve it, unless you’ve turned on auto-send.'
    },
    {
        title: 'Weekly updates',
        text: 'A short note goes out each week, even when nothing matched, so customers stop chasing you.'
    },
    {
        title: 'Pause or close',
        text: 'Pause a hunt while a customer makes up their mind. It closes on its own once the order is won.'
    }
];
export default function ProductHuntsPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('hunts'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    k: "探索",
                    label: "Product · 04 Hunts & custom orders",
                    title: "A standing search that does the legwork for every order.",
                    lead: "A hunt runs on a schedule. It reads the sheets and prices the matches, asks your agent for any sheet that’s missing, and drafts the customer shortlist for you to approve.",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-ph-card",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ph-card__head",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-card__title",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-ph-card__name",
                                                children: "Land Cruiser 80 for M. Okafor"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-ph-card__criteria",
                                                children: "HDJ81V · 1993–1997 · 4+ · diesel · no frame rust"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-ph-tag",
                                        children: "For a customer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ph-stats",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-stat",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__k",
                                                children: "Schedule"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__v",
                                                children: "Twice daily"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-stat",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__k",
                                                children: "Matches"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__v",
                                                children: "3 priced"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-stat",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__k",
                                                children: "Next update"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-stat__v",
                                                children: "Fri"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            MATCHES.map((m)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "mk-ph-match",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: m.car
                                        }),
                                        /*#__PURE__*/ _jsx("b", {
                                            className: "mk-ph-match__price",
                                            children: m.price
                                        })
                                    ]
                                }, m.car)),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ph-match",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "1994 Land Cruiser VX · — · 155k km"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-ph-match__flag",
                                        children: "Sheet requested"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ph-card__foot",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-ph-card__note",
                                        children: "Shortlist drafted in your Outbox"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pp-mini-btn",
                                        children: "Review draft"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 320,
                    children: /*#__PURE__*/ _jsx(ShopFront, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    wide: true,
                    title: "From a customer’s email to a car in your inventory.",
                    children: /*#__PURE__*/ _jsxs(ProductSteps, {
                        children: [
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "壱",
                                title: "Start from criteria, or from their email",
                                text: "Pick the filters yourself. Or, with Fastmail connected, open the customer’s email and let it fill in the hunt. You check it before it runs.",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mk-pp-step__ui",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-pair",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-email",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-ph-email__from",
                                                        children: "From: M. Okafor"
                                                    }),
                                                    "“Looking for an 80-series Land Cruiser, diesel, grade 4 or better, no frame rust. Budget around $28k delivered.”"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-panel mk-ph-filled",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-ph-filled__head",
                                                        children: "Hunt filled in"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Toyota Land Cruiser HDJ81V"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "1993–1997 · 1HD-T diesel"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Grade 4+ · no S2/C codes"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-ph-filled__muted",
                                                        children: "Budget $28,000 delivered"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "弐",
                                title: "For my shop, or for a customer",
                                text: "Shop hunts keep your lot stocked. A customer hunt carries that customer’s name and sends them updates.",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mk-pp-step__ui",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-panel mk-ph-choice",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-choice__opt",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-ph-choice__name",
                                                        children: "For my shop"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-ph-choice__desc",
                                                        children: "Notify me. No customer emails."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-choice__opt mk-ph-choice__opt--on",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-ph-choice__name",
                                                        children: "For a customer ✓"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mk-ph-choice__desc",
                                                        children: "Shortlists and weekly updates, drafted."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "参",
                                title: "It reads and prices lots, and chases sheets",
                                text: "Each run reads new sheets and prices every match. When a grade-4+ lot has no sheet, it can ask your agent for one from your mailbox.",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mk-pp-step__ui",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-panel mk-ph-log",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-log__row mk-ph-log__row--head",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "04:00 run · 14 lots checked"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-ph-log__day",
                                                        children: "Thu"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-log__row",
                                                children: "✓ 2 sheets read · 2 matches priced"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mk-ph-log__row mk-ph-log__row--last",
                                                children: "✉ Asked your agent for the sheet on Lot 50981"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "四",
                                title: "The win becomes a car in inventory",
                                text: "Confirm the win and the car is already a car record, tied to the customer, the sheet and every document that comes after.",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mk-pp-step__ui",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-panel mk-ph-won",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-ph-won__car",
                                                children: [
                                                    /*#__PURE__*/ _jsx("b", {
                                                        className: "mk-ph-won__name",
                                                        children: "1995 Toyota Land Cruiser VX"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-ph-won__meta",
                                                        children: "HDJ81-0061234 · for M. Okafor"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-ph-won__pill",
                                                children: "Won → Inventory"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("section", {
                    className: "mk-ph-details mk-ground--kinari",
                    children: /*#__PURE__*/ _jsxs(Container, {
                        className: "mk-ph-details__inner",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "mk-ph-details__title",
                                children: "Details for shops running orders"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-ph-details__grid",
                                children: DETAILS.map((d)=>/*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ph-detail",
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                className: "mk-ph-detail__title",
                                                children: d.title
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mk-ph-detail__text",
                                                children: d.text
                                            })
                                        ]
                                    }, d.title))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    title: "Hunt questions",
                    items: [
                        [
                            'How many hunts can I run?',
                            'One for every order you have, plus your own shop searches.'
                        ],
                        [
                            'Does it bid for me?',
                            'No. Hunts find lots and read and price them. Deciding on a bid and placing it is up to you.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 05",
                    title: "Bidding & wins",
                    go: "入札 →",
                    href: MKT.product('bidding')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
